import { Navigate, useParams } from "react-router";

import { contactName } from "../palmtree/badges";
import type { Contact } from "../types";

const ToContactpersonen = () => <Navigate to="/contactpersonen" replace />;

const ToNieuwContact = () => (
  <Navigate to="/contactpersonen?nieuw=person" replace />
);

const ToContactCard = () => {
  const { id } = useParams();
  return <Navigate to={`/contacten/${id}`} replace />;
};

const ToContactEdit = () => {
  const { id } = useParams();
  return <Navigate to={`/contacten/${id}/bewerken`} replace />;
};

export const LegacyZoek = () => (
  <Navigate to="/contactpersonen?focus=1" replace />
);

export const LegacyPartners = () => <Navigate to="/contactpersonen" replace />;

export default {
  list: ToContactpersonen,
  show: ToContactCard,
  edit: ToContactEdit,
  create: ToNieuwContact,
  recordRepresentation: (record: Contact) =>
    record ? contactName(record) : "",
};
